import Cookies from 'js-cookie'

import { storageKey } from '@constants/index'

export const setToken = (tokenName: string, token: string, expires?: Date) => {
  Cookies.set(tokenName, token, { expires, sameSite: 'strict' })
}

export const saveToken = (token: string) => {
  setToken(storageKey.authToken.key, token)
}

export const removeToken = (tokenName: string): void => {
  try {
    Cookies.remove(tokenName)
  } catch (e) {
    console.log(e)
  }
}
